<header class="cover">
    <div class="cover--imageBackground">
        <img [src]="company.home_image.original">
    </div>
    <div class="container">
        <div class="row">
            <div class="col-md-8 col-lg-6 p-4 position-relative mt-5">
                <div class="transparent-bg d-none d-md-block"></div>
                <div class="row">
                    <div class="col-12">
                        <h3 class="cover--title text-primary mb-0">{{ company.home_text_title}}</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-9 col-md-6">
                        <hr>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-10 col-lg-12">
                        <p class="cover--description text-secondary mt-1">{{ company.home_text_description }}</p>
                    </div>
                </div>
                <div class="row" *ngIf="company.allow_registration">
                    <div class="col">
                        <a [routerLink]="['/register']" [state]="{ ignoreLoadingBar: true }" class="btn btn-info btn-flex btn-click-effect mt-3">Crear cuenta</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>
